import { useTranslation } from 'react-i18next';

import { useLocation } from '@tanstack/react-router';
import { FolderUpIcon, HomeIcon, ImagesIcon, LayoutDashboardIcon, User2Icon } from 'lucide-react';

import { SidebarLink } from '@/components/ui/sidebar-link';
import { env } from '@/constants/env';
import { parseStringToBool } from '@/utils/parseStringToBool';

import { TenantSidebarLink } from './tenant-sidebar-link';

type SidebarProps = {
  isVisible: boolean;
  closeMobileSidebarMenu: () => void;
};

export const Sidebar = ({ isVisible, closeMobileSidebarMenu }: SidebarProps) => {
  const { t } = useTranslation();

  const { pathname } = useLocation();

  return (
    <aside
      className={`${
        isVisible
          ? 'top-[70px] z-50 h-[calc(100vh-70px)] px-2 ease-linear max-md:absolute max-md:left-0 max-md:flex max-md:w-full max-md:translate-x-0 max-md:bg-white sm:top-[107px] sm:h-[calc(100vh-107px)]'
          : 'z-50 h-[calc(100vh-70px)] max-lg:absolute max-lg:left-0 max-lg:top-[70px] max-lg:-translate-x-full sm:h-[calc(100vh-107px)]'
      } w-full max-w-[273px] flex-col bg-transparent py-6 transition-all duration-200 lg:flex`}
    >
      <nav className="flex flex-col gap-1" onClick={closeMobileSidebarMenu}>
        <SidebarLink to="/">
          <LayoutDashboardIcon /> {t('dashboard')}
        </SidebarLink>
        <TenantSidebarLink />
        <SidebarLink to="/estates">
          <HomeIcon /> <p>{t('estates')}</p>
        </SidebarLink>
        {pathname.startsWith('/estates') && (
          <SidebarLink to="/estates/me" className="ml-5" inactiveProps={{ className: 'ml-5' }}>
            <FolderUpIcon /> <p>{t('myEstates')}</p>
          </SidebarLink>
        )}
        <SidebarLink to="/profile">
          <User2Icon /> <p>{t('profile')}</p>
        </SidebarLink>
        {parseStringToBool(env.IMAGE_RENDERING) ? (
          <SidebarLink to="/image-rendering">
            <ImagesIcon /> <p>{t('rendering')}</p>
          </SidebarLink>
        ) : null}
      </nav>
    </aside>
  );
};
